import { Builder } from '@builder.io/react';

import DataInputs from './index';

Builder.registerComponent(DataInputs, {
  name: 'DataInputsModular',
  inputs: [
    { name: 'type', type: 'string', defaultValue: 'common', enum: ['minimalistic', 'common'] },
    {
      name: 'dataInputSection',
      type: 'list',
      defaultValue: [],
      subFields: [
        {
          name: 'label',
          type: 'string'
        },
        {
          name: 'sectionColor',
          type: 'string',
          defaultValue: 'text-scale-mauve',
          enum: [
            'text-scale-lightmauve',
            'text-scale-mauve',
            'text-scale-lightskyblue',
            'text-scale-skyblue',
            'text-scale-periwinkle'
          ]
        },
        {
          name: 'dataInputs',
          type: 'list',
          defaultValue: [],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'icon',
              type: 'object',
              subFields: [
                { name: 'src', type: 'file', allowedFileTypes: ['svg', 'png'] },
                { name: 'alt', type: 'string' }
              ]
            }
          ]
        }
      ]
    }
  ]
});
